import { render, staticRenderFns } from "./expand.vue?vue&type=template&id=2253e490&lang=pug&"
import script from "./expand.vue?vue&type=script&lang=js&"
export * from "./expand.vue?vue&type=script&lang=js&"
import style0 from "./expand.vue?vue&type=style&index=0&scope=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports